import { Container, TextoContainer, TitleContainer } from "./style";
import {
  FaExclamationTriangle,
  FaCheck,
  FaExclamationCircle,
} from "react-icons/fa";
import { HiX } from "react-icons/hi";
import { ReactNode, useState } from "react";

interface IInformacao {
  type?: "atencao" | "erro" | "info" | "sucesso" | "preto";
  mensagem: string | ReactNode;
  showBotaoFechar?: boolean;
  showLabel?: boolean;
  className?: string;
  title?: boolean;
  style?: React.CSSProperties | undefined;
  typeTexto?: "atencao" | "erro" | "info" | "sucesso" | "preto";
  icone?: ReactNode;
}

export function Informacao({
  type = "info",
  mensagem,
  showBotaoFechar = true,
  showLabel = true,
  className,
  title = true,
  style,
  typeTexto,
  icone = undefined,
}: IInformacao) {
  const [mostrar, setMostrar] = useState(true);

  function handleClickBotaoFechar() {
    setMostrar(false);
  }

  const cardStrategy = {
    atencao: (
      <span>
        {icone ?? <FaExclamationTriangle />}
        {showLabel && "Atenção"}
      </span>
    ),
    sucesso: (
      <span>
        <FaCheck />
        {showLabel && "Sucesso"}
      </span>
    ),
    erro: (
      <span>
        <FaExclamationCircle />
        {showLabel && "Erro"}
      </span>
    ),
    info: (
      <span>
        <FaExclamationCircle />
        {showLabel && "Info"}
      </span>
    ),
  };

  return (
    <Container
      className={className}
      mostrar={mostrar}
      showLabel={showLabel}
      type={type}
      style={style}
    >
      {title && type !== "preto" && (
        <TitleContainer type={type}>
          {cardStrategy[type]}
          {showBotaoFechar && (
            <HiX className="btnFechar" onClick={handleClickBotaoFechar} />
          )}
        </TitleContainer>
      )}
      <TextoContainer type={typeTexto}>{mensagem}</TextoContainer>
    </Container>
  );
}
